import React from "react";
import "./section5Element.css";

const Section5Element = ({percentageValue, paragraphInfo}) => {
  return (
    <div className="section5Element-main-wrapper">
      <div className="Section5Element-inner-wrapper">
        <div className="Section5Element-Percentage">
          <h5>{percentageValue}</h5>
        </div>
        <div className="Section5Element-Paragraph">
          <p>{paragraphInfo}</p>
        </div>
      </div>
    </div>
  );
};

export default Section5Element;
